module.exports = __webpack_public_path__ + "static/media/Koopa.c2215c99.gif";